export const SystemSetupEndpoint = {
  CREATE_INVERTER_TYPE: '/default/system-setup/create-inverter-type',
  CREATE_BATTERY_INVERTER_TYPE: '/default/system-setup/create-battery-inverter-type',
  CREATE_MODULE_TYPE: '/default/system-setup/create-module-type',
  CHECK_INVERTER_TYPE_NAME: '/default/system-setup/check-inverter-type-name',
  CHECK_BATTERY_INVERTER_TYPE_NAME: '/default/system-setup/check-battery-inverter-type-name',
  CHECK_MODULE_TYPE_NAME: '/default/system-setup/check-module-type-name',
};
